import { render, staticRenderFns } from "./pcIndex.vue?vue&type=template&id=467b5550&"
import script from "./pcIndex.vue?vue&type=script&lang=js&"
export * from "./pcIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports